import KnightImage from '../assets/loaders/knight.png';
import RogueImage from '../assets/loaders/rogue.png';
import SageImage from '../assets/loaders/sage.png';
import WizardImage from '../assets/loaders/wizard.png';

export const CHARACTER_IMAGE_URLS = {
  Knight: KnightImage,
  Rogue: RogueImage,
  Sage: SageImage,
  Wizard: WizardImage
} as const;

export type CharacterImageType = keyof typeof CHARACTER_IMAGE_URLS;

export const CHARACTER_IMAGE_NAMES: CharacterImageType[] = ['Knight', 'Rogue', 'Sage', 'Wizard'];
